export enum FloatingMenuItemEnum {
  ReportBug = 'REPORT_BUG',
  Chat = 'CHAT',
  QuickCalculations = 'QUICK_CALCULATIONS',
}